<script lang="ts">
  // RoundToast — banner central pulsante com mensagem narrativa.
  // Cores por tipo: win (verde), lose (vermelho), draw (amarelo).
  // Sizes: big (~2s, hand-end events) e small (~1s, per-trick events).
  // Subscreve toastStore — qualquer push spawna a versao animada.
  import { toastMessage } from '../../stores/narration';

  // Reactivity: o store emite {text, kind, size, key}. key muda a cada
  // push pra forcar re-animacao mesmo se o texto for igual.
</script>

{#if $toastMessage}
  <div
    class="toast {$toastMessage.kind} {$toastMessage.size}"
    role="status"
    aria-live="polite"
    data-key={$toastMessage.key}
  >
    {$toastMessage.text}
  </div>
{/if}

<style>
  .toast {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-3deg);
    z-index: 1300;
    color: #fff;
    font-family: "Impact", "Bebas Neue", "Arial Black", sans-serif;
    font-weight: 900;
    font-style: italic;
    letter-spacing: 1.5px;
    line-height: 1.1;
    text-align: center;
    max-width: min(90vw, 600px);
    white-space: normal;
    word-wrap: break-word;
    pointer-events: none;
    text-shadow:
      -3px -3px 0 #000, 3px -3px 0 #000, -3px 3px 0 #000, 3px 3px 0 #000,
      0 -3px 0 #000, 0 3px 0 #000, -3px 0 0 #000, 3px 0 0 #000,
      0 0 18px rgba(0, 0, 0, 0.7);
    animation: comic-pop 0.25s cubic-bezier(0.2, 1.4, 0.4, 1);
  }

  .toast.win  { color: #2ecc71; }
  .toast.lose { color: #ff4c7e; }
  .toast.draw { color: #f1c40f; }

  .toast.big   { font-size: 40px; }
  .toast.small {
    font-size: 26px;
    letter-spacing: 1px;
    transform: translate(-50%, -50%) rotate(0);
    animation-name: pop-small;
  }

  @keyframes comic-pop {
    0% { transform: translate(-50%, -50%) scale(0.3) rotate(-8deg); opacity: 0; }
    60% { transform: translate(-50%, -50%) scale(1.12) rotate(-4deg); opacity: 1; }
    100% { transform: translate(-50%, -50%) scale(1) rotate(-3deg); opacity: 1; }
  }
  @keyframes pop-small {
    0% { transform: translate(-50%, -50%) scale(0.5); opacity: 0; }
    70% { transform: translate(-50%, -50%) scale(1.08); opacity: 1; }
    100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
  }

  @media (max-width: 520px) {
    .toast.big   { font-size: 26px; letter-spacing: 0.5px; }
    .toast.small { font-size: 18px; }
  }
</style>
